<template>
  <div class="header" :style="`height:300px; 
                               background-image: url('${bDashboard}') !important;`" 
                      :class="{[`bg-${type}`]: type}">
    <div class="container-fluid">
      <div class="header-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
  // import { mapGetters } from 'vuex'
  export default {
    name: 'base-header',
    props: {
      type: {
        type: String,
        default: 'primary',
        description: 'Header background type'
      }
    },
    computed: {
        bDashboard () {
          if(this.$route.name=='dashboard'){
            return this.$store.getters.bDashboard
          }else if(this.$route.name=='class-list' || this.$route.name=='member-list'){
            return this.$store.getters.bKelas
          }else if(this.$route.name=='class-detail' || this.$route.name=='subject-list'){
            return this.$store.getters.bMapel
          }else if(this.$route.name=='subject-detail'){
            return this.$store.getters.bModul
          }else if(this.$route.name=='study-instructions'){
            return this.$store.getters.bPetunjuk
          }else if(this.$route.name=='student-progress'){
            return this.$store.getters.bPerkembangan
          }else if(this.$route.name=='modul-detail'){
            return this.$store.getters.bMateri
          }else if(this.$route.name=='modul-discuss'){
            return this.$store.getters.bDiskusi
          }else if(this.$route.name=='task-list' || this.$route.name=='student-task-list' || this.$route.name=='ujian'){
            return this.$store.getters.bPenugasan
          }else if(this.$route.name=='appraisal-list' || this.$route.name=='student-appraisal-list' || this.$route.name=='modul-appraisal-question' || this.$route.name=='appraisal-test'){
            return this.$store.getters.bPenilaian
          }else if(this.$route.name=='user-setting-list'){
            return this.$store.getters.bUser
          }else if(this.$route.name=='user-activity'){
            return this.$store.getters.bAktivitas
          }else if(this.$route.name=='user-absence'){
            return this.$store.getters.bAbsensi
          }else if(this.$route.name=='background-setting-list'){
            return this.$store.getters.bBackground
          }else if(this.$route.name=='profile'){
            return this.$store.getters.bProfile
          }else{
            return this.$store.getters.bDashboard
          }
        }
    },
    watch: {
      bDashboard() {
        console.log("");
      }
    }
  }
</script>
<style>
</style>